<template>
    <v-container fluid>
        <v-form ref="form" @submit.prevent="save">
            <v-card class="mb-5 pa-2">
                <card-header title="Editar Perfil" />
                <v-card-text v-if="model">
                    <v-row>
                        <v-col cols="12" xs="12" sm="12" md="6">
                            <v-text-field
                                v-model="model.name"
                                :label="$t('users-form.labels.name')"
                                :counter="80"
                                :error-messages="nameErrors"
                                @input="$v.model.name.$touch()"
                                @blur="$v.model.name.$touch()"
                                autofocus
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="6">
                            <v-text-field
                                v-model="model.email"
                                :label="$t('users-form.labels.email')"
                                :counter="70"
                                :error-messages="emailErrors"
                                @input="$v.model.email.$touch()"
                                @blur="$v.model.email.$touch()"
                            ></v-text-field>
                        </v-col>
                        <template>
                            <v-col cols="12" xs="12" sm="12" md="6">
                                <v-text-field
                                    v-model="model.password"
                                    type="password"
                                    :label="$t('users-form.labels.password')"
                                    :error-messages="passwordErrors"
                                    @input="$v.model.password.$touch()"
                                    @blur="$v.model.password.$touch()"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" xs="12" sm="12" md="6">
                                <v-text-field
                                    v-model="model.password_confirmation"
                                    type="password"
                                    :label="
                                        $t(
                                            'users-form.labels.password-confirmation',
                                        )
                                    "
                                    :error-messages="passwordConfirmationErrors"
                                    @input="
                                        $v.model.password_confirmation.$touch()
                                    "
                                    @blur="
                                        $v.model.password_confirmation.$touch()
                                    "
                                ></v-text-field>
                            </v-col>
                        </template>
                    </v-row>
                </v-card-text>
                <form-actions :loadingSave="loading" />
            </v-card>
        </v-form>
    </v-container>
</template>

<script>
import CardHeader from '@/components/utils/CardHeader'
import Profile from '@/models/Profile'
import FormActions from '@/components/utils/FormActions'
import { validationMixin } from 'vuelidate'
import {
    required,
    minLength,
    maxLength,
    email,
    sameAs,
} from 'vuelidate/lib/validators'

export default {
    data: () => {
        return {
            loading: false,
            model: null,
        }
    },

    components: {
        'card-header': CardHeader,
        'form-actions': FormActions,
    },

    mixins: [validationMixin],

    validations() {
        return {
            model: {
                name: { required, maxLength: maxLength(80) },
                email: { required, email },
                password: { minLength: minLength(6) },
                password_confirmation: { sameAs: sameAs('password') },
            },
        }
    },

    methods: {
        async save() {
            this.loading = true

            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$bus.$emit(
                    'notify',
                    'error',
                    this.$t('form.validation-error'),
                )

                this.loading = false
                return
            }

            let clone = this.model.clone()

            delete clone.id

            let res = null

            try {
                res = await clone.save().catch(() => {})
            } finally {
                this.loading = false
            }

            if (!res) return

            this.$emit('saved')

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('users-form.bus.save-success', { name: clone.name }),
            )
        },
    },

    computed: {
        nameErrors() {
            const errors = []
            if (!this.$v.model.name.$dirty) return errors

            !this.$v.model.name.maxLength &&
                errors.push(
                    this.$t('users-form.messages.name-error-max-length'),
                )

            !this.$v.model.name.required &&
                errors.push(this.$t('users-form.messages.name-error-required'))
            return errors
        },

        emailErrors() {
            const errors = []
            if (!this.$v.model.email.$dirty) return errors

            !this.$v.model.email.required &&
                errors.push(this.$t('users-form.messages.email-error-required'))

            !this.$v.model.email.email &&
                errors.push(this.$t('users-form.messages.email-error-email'))

            return errors
        },

        passwordErrors() {
            const errors = []
            if (!this.$v.model.password.$dirty) return errors

            !this.$v.model.password.minLength &&
                errors.push(
                    this.$t('users-form.messages.password-error-min-length'),
                )

            return errors
        },

        passwordConfirmationErrors() {
            const errors = []
            if (!this.$v.model.password_confirmation.$dirty) return errors

            !this.$v.model.password_confirmation.sameAs &&
                errors.push(
                    this.$t('users-form.messages.password-error-confirmation'),
                )
            return errors
        },
    },

    async mounted() {
        let model = new Profile()

        let res = await model.get()

        this.model = res
    },
}
</script>
